import { render, staticRenderFns } from "./Recipiente.vue?vue&type=template&id=f4d4695a&scoped=true&"
import script from "./Recipiente.vue?vue&type=script&lang=js&"
export * from "./Recipiente.vue?vue&type=script&lang=js&"
import style0 from "./Recipiente.vue?vue&type=style&index=0&id=f4d4695a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d4695a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VImg,VRow,VSelect})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4d4695a')) {
      api.createRecord('f4d4695a', component.options)
    } else {
      api.reload('f4d4695a', component.options)
    }
    module.hot.accept("./Recipiente.vue?vue&type=template&id=f4d4695a&scoped=true&", function () {
      api.rerender('f4d4695a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Modal/Recipiente.vue"
export default component.exports